module.exports = __webpack_public_path__ + "static/media/1011080.811363b8.jpg";